import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitleContainer: {
        position: "absolute",
        left: 0,
        right: 0
    },
    headerTitle: {
        alignSelf: "center"
    },
    profilePhotoWrapper: {
        alignSelf: "center"
    },
    profilePhotoImage: {
        width: 95,
        height: 95
    },
    photoEditButton: {
        position: "absolute"
    },
    dialogHeaderContainer: {
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center"
    },
    dialogIconWrapper: {
        alignSelf: "center"
    },
    dialogTitle: {
        textAlign: "center"
    }
});
export default stylesheet;
